<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{ props.row.TerminalQty }}</a>
  </div>
</template>

<script>
import store from "../../../../store/index";
export default {
  name: "terminalesLink",
  show(ops) {
    store.dispatch("getAllTerminals", {
      rnc: ops.row.Rnc
    });
  }
};
</script>
